(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trazos-prints-calculator"] && !Shopify.designMode) return;
  try {
    

function trazosQuantityDiscount(quantity) {
  return quantity >= 25000 ? 0.10 : quantity >= 10000 ? 0.05 : 0;
}

function initializeTrazosCalculator(root) {
  if (root.dataset.initialized === "true") return;
  root.dataset.initialized = "true";
  const error = root.querySelector('[data-field="error"]');
  const results = root.querySelector('[data-field="results"]');
  const fields = [
    ['unit', 'Blank item cost'], ['quantity', 'Quantity'], ['markup', 'Markup'],
    ['ink-price', 'Ink cost'], ['ink-usage', 'Ink usage'], ['other', 'Other costs'], ['setup', 'Setup / labor']
  ];
  const currency = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
  const preciseCurrency = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 4 });
  const number = new Intl.NumberFormat('en-US', { maximumFractionDigits: 3 });
  function output(key, value) { root.querySelector('[data-out="' + key + '"]').textContent = value; }
  function parseDecimal(raw) {
    const text = raw.trim().replace(',', '.');
    return /^(?:\d+(?:\.\d*)?|\.\d+)$/.test(text) ? Number(text) : NaN;
  }
  function update() {
    const markupValue = parseDecimal(root.querySelector('[data-field="markup"]').value);
    root.querySelectorAll('[data-markup]').forEach(button => button.setAttribute('aria-pressed',String(Number(button.dataset.markup) === markupValue)));
    const v = {};
    let message = '';
    for (const [key, label] of fields) {
      const input = root.querySelector('[data-field="' + key + '"]');
      const value = parseDecimal(input.value);
      const invalid = !Number.isFinite(value) || value < 0 || (key === 'quantity' && (!Number.isSafeInteger(value) || value < 1));
      input.setAttribute('aria-invalid', String(invalid));
      if (invalid && !message) message = key === 'quantity' ? 'Enter a whole-number quantity of at least 1.' : 'Enter a valid nonnegative number for ' + label.toLowerCase() + '.';
      v[key] = value;
    }
    if (message) {
      error.textContent = message; error.hidden = false; results.hidden = true; return false;
    }
    const ink = v['ink-price'] / 1000 * v['ink-usage'];
    const totalCost = (v.unit + ink + v.other) * v.quantity + v.setup;
    const unitCost = totalCost / v.quantity;
    const discount = trazosQuantityDiscount(v.quantity);
    const rawCents = unitCost * (1 + v.markup / 100) * (1 - discount) * 100;
    const priceCents = Math.max(0, Math.ceil(rawCents - Math.max(1, rawCents) * Number.EPSILON * 8));
    const revenueCents = priceCents * v.quantity;
    const inkNeeded = v['ink-usage'] * v.quantity;
    if (!Number.isSafeInteger(priceCents) || !Number.isSafeInteger(revenueCents) || !Number.isFinite(totalCost) || !Number.isFinite(inkNeeded)) {
      error.textContent = 'These values are too large to calculate reliably. Please enter smaller values.';
      error.hidden = false; results.hidden = true; return false;
    }
    error.hidden = true; error.textContent = ''; results.hidden = false;
    const price = priceCents / 100;
    const revenue = revenueCents / 100;
    const profitDifference = revenue - totalCost;
    const profit = Math.abs(profitDifference) <= Number.EPSILON * Math.max(1, revenue, totalCost) * 8 ? 0 : profitDifference;
    output('discount-status', discount === 0.10 ? '10% quantity discount · 25,000+ units' : discount === 0.05 ? '5% quantity discount · 10,000–24,999 units' : 'No quantity discount · under 10,000 units');
    const warning = root.querySelector('[data-out="discount-warning"]');
    warning.hidden = profit >= 0;
    warning.textContent = profit < 0 ? 'This selling price is below your entered cost. Increase the markup to avoid a loss.' : '';
    output('price', currency.format(price));
    output('revenue', currency.format(revenue));
    output('profit', currency.format(profit));
    for (const [key, unit, total] of [
      ['blank', v.unit, v.unit * v.quantity], ['ink', ink, ink * v.quantity],
      ['other', v.other, v.other * v.quantity], ['setup', v.setup / v.quantity, v.setup],
      ['cost', unitCost, totalCost], ['profit', profit / v.quantity, profit]
    ]) {
      output(key + '-unit', preciseCurrency.format(unit));
      output(key + '-total', currency.format(total));
    }
    output('ink-needed', number.format(inkNeeded) + ' mL');
    output('margin', revenue > 0 ? number.format(profit / revenue * 100) + '%' : 'N/A');
    return true;
  }
  root.addEventListener('input', update);
  root.querySelectorAll('[data-markup]').forEach(button => button.addEventListener('click',() => {
    root.querySelector('[data-field="markup"]').value = button.dataset.markup;
    update();
  }));
  update();
  initializeTrazosPresets(root, fields, parseDecimal, update);
}

function initializeTrazosPresets(root, fields, parseDecimal, update) {
  const key = 'trazos.print-calculator.quote-templates.v1';
  const ui = name => root.querySelector('[data-preset="' + name + '"]');
  const select = ui('select');
  const nameInput = ui('name');
  const status = ui('status');
  function tell(message, isError = false) {
    status.textContent = message;
    status.dataset.error = String(isError);
  }
  function validValues(values) {
    if (!values || typeof values !== 'object') return false;
    for (const [field] of fields) {
      if (typeof values[field] !== 'number' || !Number.isFinite(values[field]) || values[field] < 0) return false;
    }
    if (!Number.isSafeInteger(values.quantity) || values.quantity < 1) return false;
    const ink = values['ink-price'] / 1000 * values['ink-usage'];
    const cost = (values.unit + ink + values.other) * values.quantity + values.setup;
    const cents = cost / values.quantity * (1 + values.markup / 100) * (1 - trazosQuantityDiscount(values.quantity)) * 100;
    return Number.isFinite(cost) && Number.isFinite(values['ink-usage'] * values.quantity) && Number.isSafeInteger(Math.ceil(cents)) && Number.isSafeInteger(Math.ceil(cents) * values.quantity);
  }
  function decode(raw) {
    const data = JSON.parse(raw);
    if (!data || data.app !== 'trazos-print-calculator' || data.version !== 1 || !Array.isArray(data.templates) || data.templates.length > 1000) throw new Error('Invalid templates file. Choose an exported Trazos templates JSON file.');
    const ids = new Set();
    const names = new Set();
    return data.templates.map(item => {
      if (!item || typeof item.id !== 'string' || !item.id || item.id.length > 120 || ids.has(item.id) || typeof item.name !== 'string' || !item.name.trim() || item.name.length > 80 || names.has(item.name.trim().toLowerCase()) || !validValues(item.values)) throw new Error('A saved template has invalid or duplicate data. Nothing was changed.');
      ids.add(item.id); names.add(item.name.trim().toLowerCase());
      return {id:item.id, name:item.name.trim(), values:Object.fromEntries(fields.map(([field]) => [field,item.values[field]]))};
    });
  }
  function read() {
    let raw;
    try { raw = localStorage.getItem(key); }
    catch (_) { throw new Error('Browser storage is unavailable. You can still calculate and export the current quote.'); }
    if (!raw) return [];
    try { return decode(raw); }
    catch (_) { throw new Error('Saved templates could not be read. Existing browser data was left unchanged.'); }
  }
  function encode(items) { return JSON.stringify({app:'trazos-print-calculator',version:1,templates:items},null,2); }
  function write(items) {
    if (items.length > 1000) throw new Error('Template storage is full. Export a backup and remove unused templates first.');
    try { localStorage.setItem(key,encode(items)); }
    catch (_) { throw new Error('Templates could not be saved. Browser storage may be disabled or full. Export the current quote to keep a copy.'); }
    root.dispatchEvent(new CustomEvent('trazos:templates-changed',{bubbles:true}));
  }
  function syncButtons() {
    ['load','update','delete'].forEach(action => { ui(action).disabled = !select.value; });
  }
  function refresh(chosen = select.value) {
    const items = read();
    const placeholder = document.createElement('option');
    placeholder.value = ''; placeholder.textContent = items.length ? 'Choose a template' : 'No templates saved yet';
    select.replaceChildren(placeholder);
    items.sort((a,b) => a.name.localeCompare(b.name)).forEach(item => {
      const option = document.createElement('option'); option.value = item.id; option.textContent = item.name; select.appendChild(option);
    });
    select.value = items.some(item => item.id === chosen) ? chosen : '';
    syncButtons();
    return items;
  }
  function valuesNow() {
    if (!update()) throw new Error('Fix the highlighted print-job values before saving.');
    const values = Object.fromEntries(fields.map(([field]) => [field,parseDecimal(root.querySelector('[data-field="'+field+'"]').value)]));
    if (!validValues(values)) throw new Error('These values are too large to save reliably.');
    return values;
  }
  function templateName() {
    const name = nameInput.value.trim();
    if (!name || name.length > 80) throw new Error('Enter a template name of 1–80 characters.');
    return name;
  }
  function id() { return 'quote-'+Date.now().toString(36)+'-'+Math.random().toString(36).slice(2,12); }
  function selected(items) {
    const item = items.find(item => item.id === select.value);
    if (!item) throw new Error('Choose a saved template first. It may have been removed in another tab.');
    return item;
  }
  function run(action) { try { action(); } catch (error) { tell(error.message || 'This action could not be completed.',true); } }
  select.addEventListener('change',() => run(() => { syncButtons(); const item = read().find(item => item.id === select.value); if (item) nameInput.value=item.name; tell(''); }));
  ui('load').addEventListener('click',() => run(() => {
    const item = selected(read());
    fields.forEach(([field]) => { root.querySelector('[data-field="'+field+'"]').value=String(item.values[field]); });
    nameInput.value=item.name; update(); tell('Loaded “'+item.name+'”.');
  }));
  ui('save').addEventListener('click',() => run(() => {
    const name=templateName(),values=valuesNow(),items=read();
    if (items.some(item => item.name.toLowerCase()===name.toLowerCase())) throw new Error('That name already exists. Load it and choose Update selected, or use a new name.');
    const item={id:id(),name,values}; items.push(item); write(items); refresh(item.id); tell('Saved “'+name+'” in this browser.');
  }));
  ui('update').addEventListener('click',() => run(() => {
    const items=read(),item=selected(items),name=templateName(),values=valuesNow();
    if (items.some(other => other.id!==item.id && other.name.toLowerCase()===name.toLowerCase())) throw new Error('Another template already uses that name.');
    item.name=name; item.values=values; write(items); refresh(item.id); tell('Updated “'+name+'”.');
  }));
  ui('delete').addEventListener('click',() => run(() => {
    const items=read(),item=selected(items);
    if (!window.confirm('Delete the saved template “'+item.name+'”?')) return;
    write(items.filter(other => other.id!==item.id)); refresh(''); nameInput.value=''; tell('Deleted “'+item.name+'”. Current quote values were kept.');
  }));
  ui('export').addEventListener('click',() => run(() => {
    let items;
    try { items=read(); } catch (_) { items=[]; }
    if (!items.length) items=[{id:id(),name:nameInput.value.trim() || 'Current quote',values:valuesNow()}];
    const blob=new Blob([encode(items)],{type:'application/json'}),url=URL.createObjectURL(blob),link=document.createElement('a');
    link.href=url; link.download='trazos-quote-templates.json'; root.appendChild(link); link.click(); link.remove(); setTimeout(() => URL.revokeObjectURL(url),30000);
    tell('Exported '+items.length+' template(s). Store the file somewhere safe.');
  }));
  ui('import').addEventListener('click',() => { ui('file').value=''; ui('file').click(); });
  ui('file').addEventListener('change',async () => {
    const file=ui('file').files[0]; if (!file) return;
    try {
      if (file.size > 2000000) throw new Error('Choose a templates JSON file smaller than 2 MB.');
      const incoming=decode(await file.text()),items=read();
      if (!incoming.length) throw new Error('This file contains no templates.');
      const names=new Set(items.map(item => item.name.toLowerCase()));
      let renamed=0;
      incoming.forEach(item => {
        let name=item.name,index=1;
        while (names.has(name.toLowerCase())) { const suffix=' (imported '+(index++)+')'; name=item.name.slice(0,80-suffix.length)+suffix; }
        if (name!==item.name) renamed++;
        names.add(name.toLowerCase()); items.push({id:id(),name,values:item.values});
      });
      write(items); refresh(''); tell('Imported '+incoming.length+' template(s).'+(renamed?' Matching names were renamed; existing templates were kept.':''));
    } catch (error) { tell(error.message || 'Import failed. Nothing was changed.',true); }
  });
  try { refresh(''); } catch (error) { syncButtons(); tell(error.message,true); }
}

if (!customElements.get('trazos-print-calculator')) {
  customElements.define('trazos-print-calculator', class extends HTMLElement {
    connectedCallback() {
      requestAnimationFrame(() => {
        if (this.isConnected) initializeTrazosCalculator(this);
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
